import type { User } from '@auth0/auth0-spa-js'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import jwtDecode from 'jwt-decode'
import type { DecodedAccessToken } from '@/core/authClient'
import type { Tenant } from '@/core/tenant'
import { accessTokenToRbacPermissions } from '@/utilities/permission'

interface AuthState {
	accessToken?: string
	decodedAccessToken?: DecodedAccessToken
	user?: User
	userPermissions: Array<{
		action: string
		resource: string
		type?: 'allow' | 'deny'
	}>
}

const initialState: AuthState = {
	accessToken: undefined,
	decodedAccessToken: undefined,
	user: undefined,
	userPermissions: [],
}

const AuthSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAccessToken: (state, action: PayloadAction<string>) => {
			const decoded = jwtDecode<DecodedAccessToken>(action.payload)

			state.accessToken = action.payload
			state.decodedAccessToken = decoded

			return state
		},
		setUser: (state, action: PayloadAction<User>) => {
			state.user = action.payload
			return state
		},
		updateUserPermissions: (state, { payload: tenant }: PayloadAction<Tenant | null | undefined>) => {
			const { decodedAccessToken } = state
			if (!decodedAccessToken) return

			const rbacPermissions = accessTokenToRbacPermissions(decodedAccessToken.scope, tenant)

			state.userPermissions = rbacPermissions
			localStorage.setItem('wll:rbac-permissions', JSON.stringify(rbacPermissions))
			return state
		},
	},
})

export const { setAccessToken, setUser, updateUserPermissions } = AuthSlice.actions
export default AuthSlice.reducer
